import script from "./RegisterVerifyNew.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterVerifyNew.vue?vue&type=script&setup=true&lang=js"

import "./RegisterVerifyNew.vue?vue&type=style&index=0&id=5c2074c3&lang=css"

const __exports__ = script;

export default __exports__